module.exports = __webpack_public_path__ + "media/images/pages/header-bg-29abef1e9f7848b02c95e048ba4c4215.png";